import React, { useContext } from "react";
import { AppContext } from "../App";
import ImageGallery from './PhotoGallery';
import "react-image-gallery/styles/css/image-gallery.css";

export default function CollectionItemPhotos({ d }) {
    const strapiURL = useContext(AppContext)

    if (!d  || !d.Photos || !Array.isArray(d.Photos)) {
      return null; 
    }

    return (
      <div className="retro-gallery-frame">
      <ImageGallery
        items={d.Photos.map(photo => ({
          original: `${strapiURL}${photo?.formats?.large?.url || photo?.formats?.medium?.url || photo?.url || ''}`,
          thumbnail: `${strapiURL}${photo?.formats?.thumbnail?.url || photo?.url || ''}`,
          originalAlt: photo?.alternativeText || d.Name,
          thumbnailAlt: photo?.alternativeText || d.Name,
        }))}
        showFullscreenButton={true}
        showPlayButton={true}
        autoPlay={false}
        slideInterval={6000}
        slideDuration={450}
        showBullets={true}
        showThumbnails={true}
        showIndex={true}
        infinite={true}
        showNav={true}
        thumbnailPosition="top"
        useBrowserFullscreen={true}
        useWindowKeyDown={true}
      />
      </div>
    );
}
